// @flow

import React, { type Node, useCallback, useState } from 'react';
import styled from 'styled-components';
import { type VerticalAccordionModel } from './vertical-accordion-model';
import { VerticalAccordionItem } from './vertical-accordion-item';

type VerticalAccordionProps = {
  initial?: string,
  items: VerticalAccordionModel,
};

export function VerticalAccordion({ initial, items }: VerticalAccordionProps): Node {
  const [opened, setOpened] = useState<string>(initial || '');
  const toggle = useCallback((key: string) => {
    setOpened(key !== opened ? key : '');
  });

  return (
    <Root>
      {items.map(({ id, title, content }, index) => {
        return (
          <VerticalAccordionItem
            key={id}
            id={id}
            isLast={index == items.length - 1}
            isOpen={id === opened}
            onToggle={toggle}
            title={title}
          >
            {content}
          </VerticalAccordionItem>
        );
      })}
    </Root>
  );
}

const Root = styled.div`
  border: 1px solid ${props => props.theme.colors.secondaryGray[0]};
  border-radius: 5px;
`;
